export default {
  text: 'Birthday',
  thumbnail:
    'https://vastreach.com/static_assets/email/thumnails/Birthday_email.jpg',
  snippets: {
    Button: {
      icon: 'RadioButton',
      text: 'Button',
      editor: 'button',
      html: '<!-- Dynamic WYSIWYG Content --><div style="max-width: 600px;margin: 0 auto 0;padding: 10px 0;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;"><p style="text-align: center;margin:0;"><a data-button-text="Start now" data-button-url="https://www.vastreach.com" data-button-color="#ffffff" data-button-background-color="#a70fa1" href="#" target="_blank"><button style="color: #ffffff; background-color: #a70fa1; border: 0; padding: 15px 25px; margin: 0; border-radius: 0.35rem; cursor: pointer;"><strong>Start Now</strong></button></a></p></div><!-- End of Dynamic WYSIWYG Content -->',
    },
    Social: {
      icon: 'Share',
      text: 'Social',
      editor: 'social-media',
      html: '<!-- Dynamic WYSIWYG Content --><table style="margin: 0 auto;background: transparent;" border="0" cellpadding="0" cellspacing="0" align="center"><tr><td width="600" align="center"><table style="margin: 20px 0 20px 0;"><tr><td align="center"> <a data-social-media="facebook" href="https://www.facebook.com/" target="_blank"><img src="https://vastreach.com/static_assets/facebook.png" border="0" style="background-color: #800080;padding: 4px; border-radius:28px;" /></a> </td><td align="center"> <a data-social-media="instagram" href="https://www.instagram.com/" target="_blank"><img src="https://vastreach.com/static_assets/instagram.png" border="0" style="background-color: #800080;padding: 4px; border-radius:28px;" /></a> </td><td align="center"> <a data-social-media="twitter" href="https://twitter.com/" target="_blank"><img src="https://vastreach.com/static_assets/twitter.png" border="0" style="background-color: #800080;padding: 4px; border-radius:28px;" /></a> </td></tr></table></td></tr></table><!-- End of Dynamic WYSIWYG Content -->',
    },
    Paragraph: {
      icon: 'Notes',
      text: 'Paragraph',
      editor: 'wysiwyg',
      html: `<!-- Dynamic WYSIWYG Content --><div style="max-width: 600px;margin: 0 auto 0;padding: 10px 20px;text-align: center;background: transparent;"> <span style="font-size: medium;color:#000000;padding: 0;margin:0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">We have over 40 Hot Tubs & Swim Spas on Display from Major Brands and Everything Must Go! Display models are priced to move. Come see for yourself and save. Click below to save even more with a coupon just for you!</span></div><!-- End of Dynamic WYSIWYG Content -->`,
    },
    Header: {
      icon: 'Title',
      text: 'Header',
      editor: 'wysiwyg',
      html: '<!-- Dynamic WYSIWYG Content --><div style="max-width: 600px; margin: 0 auto; padding: 10px; text-align: center; background: transparent; line-height: 1.65; font-size: 100%;"><h1 style="color: #408ae6; padding: 0; text-align: center; font-weight: bold;"><span style="font-size: xxx-large;font-family: Arial, Helvetica, sans-serif;">Header</span></h1></div><!-- End of Dynamic WYSIWYG Content -->',
    },
    '2 Columns (Image + Paragraph)': {
      icon: 'VerticalSplit',
      text: '2 Columns (Image + Paragraph)',
      editor: 'wysiwyg',
      html: '<!-- Dynamic WYSIWYG Content --><table cellpadding="0" cellspacing="0" border="0" style="width: 100%;max-width: 600px;margin: 0 auto 0;padding: 0;text-align: center;background: transparent;"><tr><td width="600" align="center"><table cellpadding="0" cellspacing="0"><tr><td width="290" valign="top"><table cellpadding="0" cellspacing="0" style="padding-right: 5px;"><tr><td><img style="width: 100%; display: block; border: 0;" src="https://vastreach.com/static_assets/snippets/featured-1.jpg" width="290" alt="#" /></td></tr><tr><td align="left"><h3 style="font-size: 18px;color: #333333;padding-top: 20px;text-transform: uppercase;">This is a story headline</h3></td></tr><tr><td align="left"><p style="font-size: 14px;line-height: 20px !important;color: #777777;padding: 0;">You can place your feature or topic image above, and describe that feature or topic here in a few short sentences.</p></td></tr></table></td><td width="290" valign="top"><table cellpadding="0" cellspacing="0" style="padding-left: 5px;"><tr><td><img style="width: 100%; display: block; border: 0;" src="https://vastreach.com/static_assets/snippets/featured-2.jpg" width="290" alt="#" /></td></tr><tr><td align="left"><h3 style="font-size: 18px;color: #333333;padding-top: 20px;text-transform: uppercase;">This is a story headline</h3></td></tr><tr><td align="left"><p style="font-size: 14px;line-height: 20px !important;color: #777777;padding: 0;">You can place your feature or topic image above, and describe that feature or topic here in a few short sentences.</p></td></tr></table></td></tr></table></td></tr></table><!-- End of Dynamic WYSIWYG Content -->',
    },
    'Image Banner + Text': {
      icon: 'Satellite',
      text: 'Image Banner + Text',
      editor: 'wysiwyg',
      html: '<!-- Dynamic WYSIWYG Content --><table border="0" cellpadding="0" cellspacing="0" style="width: 100%; max-width: 600px; margin: 0 auto; padding: 0; text-align: center; background-color: #ffffff;"><tr><td valign="middle" style="background-image: url(https://vastreach.com/static_assets/snippets/customer_support.jpg);background-position: center center !important;background-size: cover !important;text-align: center;background-repeat: no-repeat;padding: 50px 0 50px 0;background-position: center;background-size: cover;"><table border="0" cellpadding="0" cellspacing="0" style="width: 100%;"><tr><td valign="middle" style="text-align: center; padding: 50px 50px 50px; font-size: 15px; line-height: 20px; color: #ffffff;"><h2 style="font-size: 35px; font-weight: 600; font-family: Tahoma, Geneva, sans-serif; word-wrap: break-word; line-height: 1.5; display: inline-block; vertical-align: middle;">YOUR STATEMENT <b style="color: #cc6699;">HERE</b></h2><p style="margin: 0; color: #ffffff; font-size: 14px; font-weight: 550; font-family: Arial, Helvetica, sans-serif;">Place a description or your mission statement here. We recommend using a darker image on lighter text or lighter image on darker text.</p></td></tr></table></td></tr></table><!-- End of Dynamic WYSIWYG Content -->',
    },
  },
  value: `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">
<html xmlns="http://www.w3.org/1999/xhtml" style="width: 100%;height: 100%;margin: 0;padding: 0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">

<head>
  <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
  <meta name="viewport" content="width=device-width"/>
  <meta class="vastreach-theme" data-vast-theme="birthday"/>
</head>
  
<body align="center" style="margin: 0;padding: 0;background-color: #ffffff;">
  <div class="background" style="background: #ffffff;">
    <div class="foreground" style="max-width: 600px;background: #ffffff;">
		<table cellpadding="0" cellspacing="0" style="max-width: 600px;margin: 0 auto;padding: 0 0 30px 0;text-align: center;border-radius: .35rem;border-spacing: 0;">
			<tr>
				<td class="vastreach-sections" data-vast-editor="img-picker">
					<!-- Dynamic WYSIWYG Content -->
					<div style="max-width: 600px;margin: 0 auto 0;padding: 10px 0;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">		  
						<img src="https://vastreach.com/static_assets/email/birthday_email/beta-logo.png" alt="logo" style="width: 100%;max-width: 200px;margin: 0 auto;display: block;">
					</div> 							
					<!-- End of Dynamic WYSIWYG Content -->
				</td>	
			</tr>	

			<tr>	
				<td class="vastreach-sections" data-vast-editor="img-picker">
					<!-- Dynamic WYSIWYG Content -->
					<div style="max-width: 600px;margin: 0 auto 0;padding: 10px 0;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">				
						<img src="https://vastreach.com/static_assets/email/birthday_email/banner.jpg" alt="happy birthday cake" style="max-width: 100%;margin: 0 auto;display: block;">
					</div> 							
					<!-- End of Dynamic WYSIWYG Content -->
				</td>	
			</tr>

			<tr>
				<td class="vastreach-sections" data-vast-editor="paragraph">
					<!-- Dynamic WYSIWYG Content -->
					<div style="max-width: 600px; margin: 0 auto; padding: 10px; text-align: center; background: transparent; line-height: 1.65; font-size: 100%;">
					<h1 style="color: #408ae6; padding: 0; text-align: center; font-weight: bold;"><span style="font-size: xxx-large;font-family: Arial, Helvetica, sans-serif;">BIRTHDAY COUPON</span></h1>
					</div>					
					<!-- End of Dynamic WYSIWYG Content -->
				</td>	
			</tr>

			<tr>
				<td class="vastreach-sections" data-vast-editor="paragraph">
					<!-- Dynamic WYSIWYG Content -->
					<div style="max-width: 600px;margin: 0 auto 0;padding: 10px 20px;text-align: center;background: transparent;">        
						<span style="font-size: medium;color:#000000;padding: 0;margin:0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">Your birthday should be the best day of the year! Here’s our gift to help make it special.</span>
					</div>						
					<!-- End of Dynamic WYSIWYG Content -->
				</td>	
			</tr>		

			<tr>
				<td class="vastreach-sections" data-vast-editor="paragraph">
					<!-- Dynamic WYSIWYG Content -->
					<div style="width: 100%;max-width: 600px;text-align: center;margin:0 auto;padding: 20px;border: 5px solid #000000;background: #800080;color: #ffffff;border-spacing: 0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">
						<h2 style="font-size: 40px;color: #ffffff;"><span style="font-family: Arial, Helvetica, sans-serif;">20% OFF!</span></h2>
						<span style="font-size: medium;color:#ffffff;padding: 0;margin:0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">Save [Amount or percent} off your next order, product or service. Make sure to provide any terms and an expiration date for the deal.</span>
					</div> 							
					<!-- End of Dynamic WYSIWYG Content -->
				</td>	
			</tr>	

			<tr>
				<td class="vastreach-sections" data-vast-editor="paragraph">
					<!-- Dynamic WYSIWYG Content -->
					<table style="width: 100%;max-width: 600px;margin: 0 auto 0;padding: 0;text-align: center;background: transparent;">
						<tr>
							<td> 				
								<table cellpadding="0" cellspacing="0" align="center" style="border-spacing: 0;padding: 30px 15px 0 15px;">
									<tr>
										<td class="col" width="290" valign="top">
											<table cellpadding="0" cellspacing="0" style="border-spacing: 0;">
												<tr>
													<td>
														<img src="https://vastreach.com/static_assets/email/birthday_email/featured-1.jpg" width="290" alt="flamingo float" style="max-width: 100%;margin: 0 auto;display: block;border: 0;" />
													</td>
												</tr>
												<tr>
													<td align="left">
														<h3 style="font-size: 18px;color: #333333;padding-top: 20px;text-transform: uppercase;">This is a story headline</h3>
													</td>
												</tr>
												<tr>
													<td align="left">
														<p style="font-size: 14px;line-height: 20px !important;color: #777777;padding: 0;">Highlight a product, product line or service here that you want to promote. Choose something that they might want to use their birthday coupon towards.</p>
													</td>
												</tr>
												<!--<tr>
													<td align="center">
													<p><a href="#" target="_blank"><button style="color: #ffffff;background-color: #a70fa1;border: 0;padding: 15px 25px; border-radius: .35rem;cursor: pointer;"><b>Learn More</b></button></a></p>
													</td>
												</tr>-->
											</table>
										</td>
										<td style="width: 20px;font-size: 1px;">&nbsp;</td>
										<td class="col" width="290" valign="top">
											<table cellpadding="0" cellspacing="0" style="border-spacing: 0;">
												<tr>
													<td><img src="https://vastreach.com/static_assets/email/birthday_email/featured-2.jpg" width="290" alt="pineapple in water" style="max-width: 100%;margin: 0 auto;display: block;border: 0;" /></td>
												</tr>
												<tr>
													<td align="left">
														<h3 style="font-size: 18px;color: #333333;padding-top: 20px;text-transform: uppercase;">This is a story headline</h3>
													</td>
												</tr>
												<tr>
													<td align="left">
														<p style="font-size: 14px;line-height: 20px !important;color: #777777;padding: 0;">Highlight a product, product line or service here that you want to promote. Choose something that they might want to use their birthday coupon towards.</p>
													</td>
												</tr>
												<!--<tr>
													<td align="center">
													<p><a href="#" target="_blank"><button style="color: #ffffff;background-color: #a70fa1;border: 0;padding: 15px 25px; border-radius: .35rem;cursor: pointer;"><b>Learn More</b></button></a></p>
													</td>
												</tr>-->
											</table>
										</td>
									</tr>
								</table>
							</td>
						</tr>
					</table> 							
					<!-- End of Dynamic WYSIWYG Content -->
				</td>
			</tr>
		</table>
	</div>		
  </div>		
</body>
</html>`,
}
